module.exports = __webpack_public_path__ + "static/media/Edit-Icon.6ed0a647.svg";